import { render, staticRenderFns } from "./TaskInput.vue?vue&type=template&id=8dc445a4&scoped=true&"
import script from "./TaskInput.vue?vue&type=script&lang=js&"
export * from "./TaskInput.vue?vue&type=script&lang=js&"
import style0 from "./TaskInput.vue?vue&type=style&index=0&id=8dc445a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc445a4",
  null
  
)

export default component.exports